import { BaseContainerModel } from "../../base-container.model";
import { bl_cms_website_coupon_hdr_links_RowClass } from "../../../dbschema/bl_cms_website_coupon_hdr_links.model";

export class WebsiteCouponHdrLinksContainerModel extends BaseContainerModel {
  bl_cms_website_coupon_hdr_link: bl_cms_website_coupon_hdr_links_RowClass =
    new bl_cms_website_coupon_hdr_links_RowClass();
}
